import styled from 'styled-components';
import { useTranslations } from 'next-intl';
import { Flex3XS } from '@/components/Flex';
import Icon from '@/components/core/Icon/Icon';
import Typography from '@/components/core/Typography';
import { device } from '@/components/Media';

const Grid = styled.div`
    display: grid;
    grid-template: 1fr 1fr / 1fr 1fr;
    gap: 12px 0;
    
    & > div {
        width: 210px;
        height: 24px;
        align-items: center;

        @media ${device.laptopS} {
            width: 100%;
        }
    }

    @media screen and ${device.laptopS} {
        width: 100%;
        grid-template-columns: 1fr;
    }
`;

const CriteriaIcon = styled(Icon)<{
    $disabled: boolean;
}>`
    color: ${({ $disabled, theme }) => $disabled ? theme.colors.palette.grey_600 : theme.colors.palette.blue_600};
`;

const CriteriaTypography = styled(Typography)<{
    $disabled: boolean;
}>`
    color: ${({ $disabled, theme }) => $disabled ? theme.colors.palette.grey_600 : theme.colors.palette.blue_600};
`;

export function PasswordCriteria({ password }) {
    const matches = {
        differentCases: /[a-zа-я]/.test(password) && /[A-ZА-Я]/.test(password),
        minLength: password.length >= 8,
        numbers: /[0-9]/.test(password),
        symbols: /[~`!@#$%^&*()_\-+={[}\]|:;"'<,>.?/]/.test(password)
    };
    const t = useTranslations();

    return (
        <Grid>
            {['differentCases', 'minLength', 'numbers', 'symbols'].map((rule, i) => (
                <Flex3XS key={i}>
                    <CriteriaIcon $disabled={!matches[rule]} name={matches[rule] ? 'checkmark-light' : 'point'} />
                    <CriteriaTypography $disabled={!matches[rule]} variant='uiType' size='sm' modifier='R'>
                        {t(`auth.passwordCriteria.${rule}`)}
                    </CriteriaTypography>
                </Flex3XS>
            ))}
        </Grid>
    );
}
